export default __webpack_public_path__ + "static/media/6.583b1b02.jpeg";